<template>
    <div :class="this.error ? ' has-error' : ''">
        <input type="file"
               :required="isRequired"
               :id="id"
               :name="name"
               :accept="accept"
               @change="onChange($event)">
        <help-block :text="error"/>
    </div>
</template>

<script>

    export default {
        props: {
            name: String,
            id: String,
            prview_image_id: String,
            accept: {
                type: String,
                default: ''
            },
            error: String,
            isRequired: {
                type: Boolean,
                default: false
            },
        },
        methods: {
            onChange(e) {
                var self = this;
                if (e.target.files && e.target.files[0]) {
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        new Vue({
                            el: '#'+self.prview_image_id,
                            data: {
                                id: null
                            },
                            mounted: function() {
                                this.$el.setAttribute('src', e.target.result);
                            }
                        });

                        //$('.avatar > img').attr('src', e.target.result);
                    };
                    reader.readAsDataURL(e.target.files[0]);
                }
            }
        }
    }
</script>

